import { render, staticRenderFns } from "./DeleteConfirmModel.vue?vue&type=template&id=4005d9e4&scoped=true&"
import script from "./DeleteConfirmModel.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmModel.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmModel.vue?vue&type=style&index=0&id=4005d9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005d9e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4005d9e4')) {
      api.createRecord('4005d9e4', component.options)
    } else {
      api.reload('4005d9e4', component.options)
    }
    module.hot.accept("./DeleteConfirmModel.vue?vue&type=template&id=4005d9e4&scoped=true&", function () {
      api.rerender('4005d9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/DeleteConfirmModel.vue"
export default component.exports